import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Home, Search } from 'lucide-react';
import { FlightTracker } from '../components/FlightTracker';

export default function FlightTrackerPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const initial = new URLSearchParams(location.search).get('flight') || '';
  const [input, setInput] = useState(initial);
  const [tracking, setTracking] = useState(initial.toUpperCase() || null);

  useEffect(() => {
    if (initial && !tracking) setTracking(initial.toUpperCase());
  }, [initial, tracking]);

  const onSubmit = (e) => {
    e.preventDefault();
    const v = (input || '').trim().toUpperCase().replace(/\s+/g, '');
    if (v.length < 3) return;
    setTracking(v);
    navigate(`/track?flight=${encodeURIComponent(v)}`, { replace: true });
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <Link to="/" className="text-sm text-slate-600 hover:text-emerald-700 inline-flex items-center gap-1.5 mb-6" data-testid="track-back-home">
          <Home className="h-4 w-4" /> Back to home
        </Link>

        <div className="bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 text-white rounded-2xl p-6 sm:p-8 mb-6">
          <div className="text-xs uppercase tracking-[0.2em] opacity-80">Flight 380</div>
          <div className="text-2xl sm:text-3xl font-bold mt-1">Live Flight Tracker</div>
          <div className="text-sm opacity-80 mt-2">Track any commercial flight in real time — position, gate, delay, ETA.</div>
        </div>

        <form onSubmit={onSubmit} className="flex gap-2 mb-6">
          <input
            type="text"
            placeholder="Enter flight code, e.g. PK786, BA215, EK001"
            value={input}
            onChange={(e) => setInput(e.target.value.toUpperCase())}
            data-testid="track-flight-input"
            className="flex-1 rounded-xl border border-slate-300 px-4 py-3 text-base font-medium tracking-wide focus:border-emerald-500 focus:ring-emerald-500/30"
            autoFocus
          />
          <button
            type="submit"
            data-testid="track-submit"
            className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold rounded-xl px-5 inline-flex items-center gap-2"
          >
            <Search className="h-4 w-4" /> Track
          </button>
        </form>

        {tracking ? (
          <FlightTracker flightIata={tracking} />
        ) : (
          <div className="bg-slate-50 border border-dashed border-slate-300 rounded-xl p-8 text-center text-sm text-slate-500">
            Enter a flight code above to start tracking.
          </div>
        )}

        <div className="text-[11px] text-slate-400 text-center mt-6">
          Powered by AirLabs · auto-refresh every 5 min while in-flight, 30 min otherwise.
        </div>
      </div>
    </div>
  );
}
